export default __webpack_public_path__ + "static/media/28_ic_fire.d5ef16a5.png";